import { KeyDevsObjectWithEntity } from '@api';
import { WithNAFallback } from '@design/components/table';
import { ColumnDef } from '@tanstack/react-table';
import { EntityCell } from '@terminal/components/entity-cell/EntityCell';
import { format } from 'date-fns';
import { t } from 'i18next';
import tableStyles from '../EventsTable.module.scss';
import { SORT_UNDEFINED } from './constants';

export const getCompanyColumns = (): ColumnDef<KeyDevsObjectWithEntity>[] => [
  {
    id: 'effectiveDate',
    header: t('calendar:table.time'),
    cell: props => {
      const { effective_date: effectiveDate } = props.row.original;

      return (
        <WithNAFallback
          check={!!effectiveDate}
          value={
            <div className={tableStyles.timeWrapper}>
              {format(new Date(effectiveDate), 'HH:mm')}
            </div>
          }
        />
      );
    },
    accessorFn: row => new Date(row.effective_date),
    sortingFn: 'datetime',
  },
  {
    id: 'ticker',
    header: t('calendar:table.asset'),
    cell: props => {
      const { entity } = props.row.original;

      return (
        <WithNAFallback
          check={!!entity?.tag}
          value={entity?.tag && <EntityCell entityTag={entity?.tag} />}
        />
      );
    },
    accessorFn: row => row.entity?.name ?? row.entity?.tag,
    sortUndefined: SORT_UNDEFINED,
  },
  {
    id: 'eventType',
    header: t('calendar:table.eventType'),
    cell: props => {
      const { event_type: eventType } = props.row.original;

      return (
        <WithNAFallback
          value={<span className={tableStyles.nortFontText}>{eventType}</span>}
        />
      );
    },
    accessorFn: row => row.event_type,
    sortUndefined: SORT_UNDEFINED,
  },
  {
    id: 'headline',
    header: t('calendar:table.headline'),
    cell: props => {
      const { headline } = props.row.original;

      return (
        <WithNAFallback
          check={!!headline}
          value={<span className={tableStyles.headline}>{headline}</span>}
        />
      );
    },
    accessorFn: row => row.headline,
    sortUndefined: SORT_UNDEFINED,
  },
];
